module.exports = __webpack_public_path__ + "static/media/al.b77b3c12.svg";